import React, { useEffect, useState } from "react";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { CircularProgress, styled } from "@mui/material";
import Cookies from "js-cookie";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { Layout } from "../components/shared/Layout/Layout";

import { DocumentManagementView } from "./DocumentManagementView/DocumentManagementView";
import { DocumentView } from "./DocumentView/DocumentView";
import { BackgroundProvider } from "@/context/BackgroundContext";
import { useTeamsAndChannels } from "@/context/TeamsAndChannelsContext";

const StyledContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  inset: "0",
  height: "100%",
  width: "100%",
}));

export const Router = () => {
  const token = Cookies.get("access_token");
  const { msalConfig } = useTeamsAndChannels();
  const [msalInstance, setMsalInstance] = useState<PublicClientApplication | null>(null);
  const [msalReady, setMsalReady] = useState(false);

  useEffect(() => {
    if (msalConfig) {
      const instance = new PublicClientApplication(msalConfig);
      instance.initialize().then(() => {
        setMsalInstance(instance);
        setMsalReady(true);
      });
    }
  }, [msalConfig]);

  if (!msalReady || !msalInstance) return <div>Loading Authentication...</div>;
  if (!token) {
    return (
      <StyledContainer data-testid="progressBar">
        <CircularProgress />
      </StyledContainer>
    );
  }
  if (msalReady && msalInstance) {
    return (
      <MsalProvider instance={msalInstance}>
        <BackgroundProvider>
          <BrowserRouter basename="doc_mgmt">
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<DocumentManagementView />} />
                <Route path="/jump-start-knowledge-base" element={<DocumentManagementView />} />
                <Route path="/document-viewer" element={<DocumentView />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </BackgroundProvider>
      </MsalProvider>
    );
  }
};
